import { motion } from 'framer-motion';

export default function TriviaPopup({ onLetsGo, onSkip }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 px-4"
    >
      <motion.div
        initial={{ scale: 0.92, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        transition={{ duration: 0.35, ease: 'easeOut' }}
        className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl"
      >
        {/* Brain Icon */}
        <div className="mb-4 flex justify-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#2e7d32]/10">
            <svg className="h-6 w-6 text-[#2e7d32]" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2c-1 0-2 1-2 2v1c0 .55.45 1 1 1s1-.45 1-1V4c0-.55.45-1 1-1s1 .45 1 1v1c0 .55.45 1 1 1s1-.45 1-1V4c0-1-1-2-2-2z" />
              <path d="M6 6c-1.1 0-2 .9-2 2v3h2v-3c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v3h2V8c0-1.1-.9-2-2-2H6z" />
              <path d="M4 11h2v7c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-7h2v7c0 2.2-1.8 4-4 4H8c-2.2 0-4-1.8-4-4v-7z" />
            </svg>
          </div>
        </div>

        <h2 className="mb-3 text-center text-xl font-semibold text-gray-800">Daily Health Scenarios</h2>

        <p className="mb-6 text-center text-gray-600 leading-relaxed">
          A new set of health scenario questions are available today. Answering them is optional and meant to help you learn more about wellness.
        </p>

        <div className="flex justify-end gap-4">
          <button
            onClick={onSkip}
            className="rounded-lg px-5 py-2.5 text-gray-700 transition hover:bg-gray-100"
          >
            Skip
          </button>

          <motion.button
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
            onClick={onLetsGo}
            className="rounded-lg bg-[#2e7d32] px-6 py-2.5 font-medium text-white shadow transition hover:bg-[#25632a]"
          >
            Start Scenarios
          </motion.button>
        </div>
      </motion.div>
    </motion.div>
  );
}